"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var StylePermissionStore_1 = __importDefault(require("DreamCoat/Permissions/StylePermissionStore/StylePermissionStore"));
var Types_1 = require("DataStores/Account/Types");
var mobx_1 = require("mobx");
var QuoteStyleSection_1 = __importDefault(require("DreamCoat/StyleToolBar/QuoteStyleToolBar/QuoteStyleSection"));
var BlockStore_1 = __importDefault(require("Project/Stores/BlockStore"));
var BrandStore_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandStore/BrandStore"));
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var Telemetry_1 = require("Common/Telemetry/Telemetry");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var inversify_react_1 = require("inversify-react");
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var c = (0, BemBuilder_1.default)("quote-section-toolbar");
var SectionToolbar = (function (_super) {
    __extends(SectionToolbar, _super);
    function SectionToolbar() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.trackContextualStylesClicked = function () {
            _this.telemetry.trackOnly("Block Styles Contextual Viewed", {}, {
                blockIntercom: true,
            });
        };
        return _this;
    }
    SectionToolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, sectionRef = _a.sectionRef, section = _a.section, additionalItems = _a.additionalItems;
        var allowQuoteStyle = this.stylePermissionStore.allowStyle(Types_1.StyleAccessType.ToolbarQuote);
        return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 4 }, function () { return (react_1.default.createElement(kaleidoscope_1.Toolbar, { autoStack: true, positionType: kaleidoscope_1.ToolbarPositionType.Element, element: sectionRef.current, visible: _this.sectionSelected, className: c() },
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ArrowUp, null), tooltip: { content: "move up" }, disabled: (0, lodash_1.first)(_this.quote.sections) === section, onClick: function () {
                    _this.quote.reorderSection(section, QuoteSectionStore_1.ReorderDirection.Up);
                    _this.quoteTelemetry.trackMoveSection();
                } }),
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ArrowDown, null), tooltip: { content: "move down" }, disabled: (0, lodash_1.last)(_this.quote.sections) === section, onClick: function () {
                    _this.quote.reorderSection(section, QuoteSectionStore_1.ReorderDirection.Down);
                    _this.quoteTelemetry.trackMoveSection();
                } }),
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Copy, null), tooltip: { content: "clone" }, onClick: function () {
                    _this.quote.cloneSection(section);
                    _this.quoteTelemetry.trackAddSection("cloned", section.displayMode);
                } }),
            allowQuoteStyle && (react_1.default.createElement(kaleidoscope_1.Popover, { theme: kaleidoscope_1.PopoverTheme.Dark, autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Styles, null), tooltip: { content: "section style" } }))); }, size: kaleidoscope_1.PopoverSize.Auto, className: c("style-popover"), offset: 8, onChange: function (isOpen) { return isOpen && _this.trackContextualStylesClicked(); } },
                react_1.default.createElement(QuoteStyleSection_1.default, { brandStore: _this.brandStore, blockStore: _this.blockStore, telemetry: _this.telemetry }))),
            !!additionalItems && additionalItems,
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Delete, null), tooltip: { content: "delete section" }, isDestructive: true, disabled: _this.quote.sections.length <= 1, disabledReason: "Can't delete last section", onClick: function () {
                    _this.quote.deleteSection(section);
                    _this.quoteTelemetry.trackDeleteSection();
                } }))); }));
    };
    Object.defineProperty(SectionToolbar.prototype, "sectionSelected", {
        get: function () {
            var section = this.props.section;
            return this.quoteViewStore.selectedSectionId === section.id;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f, _g;
    __decorate([
        (0, inversify_react_1.resolve)("stylePermissionStore"),
        __metadata("design:type", typeof (_a = typeof StylePermissionStore_1.default !== "undefined" && StylePermissionStore_1.default) === "function" ? _a : Object)
    ], SectionToolbar.prototype, "stylePermissionStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("blockStore"),
        __metadata("design:type", typeof (_b = typeof BlockStore_1.default !== "undefined" && BlockStore_1.default) === "function" ? _b : Object)
    ], SectionToolbar.prototype, "blockStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("brandStore"),
        __metadata("design:type", typeof (_c = typeof BrandStore_1.default !== "undefined" && BrandStore_1.default) === "function" ? _c : Object)
    ], SectionToolbar.prototype, "brandStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("telemetry"),
        __metadata("design:type", typeof (_d = typeof Telemetry_1.Telemetry !== "undefined" && Telemetry_1.Telemetry) === "function" ? _d : Object)
    ], SectionToolbar.prototype, "telemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_e = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _e : Object)
    ], SectionToolbar.prototype, "quoteViewStore", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_f = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _f : Object)
    ], SectionToolbar.prototype, "quote", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_g = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _g : Object)
    ], SectionToolbar.prototype, "quoteTelemetry", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SectionToolbar.prototype, "sectionSelected", null);
    SectionToolbar = __decorate([
        mobx_react_1.observer
    ], SectionToolbar);
    return SectionToolbar;
}(react_1.default.Component));
exports.default = SectionToolbar;
